import { forwardRef, type SVGProps } from 'react';

export type FigmaBackIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaBackIcon = forwardRef<SVGSVGElement, FigmaBackIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      clipRule="evenodd"
      d="M5.70717 7.99998L10.3537 3.35358L9.64657 2.64648L4.29297 7.99998L9.64657 13.3536L10.3537 12.6465L5.70717 7.99998Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
));

FigmaBackIcon.displayName = 'FigmaBackIcon';
